import { FC } from 'react';

import { IEditorRule } from '@entities/routing/config-version';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack, Switch, TableCell } from '@mui/material';

interface IProps {
  rule: IEditorRule;
  // Unlocks the switch and adds the actions cell.
  isEditing: boolean;
  onToggle: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

// The tail of a rule row: On/Off in both modes — locked outside edit mode like the policy
// switch (a config edit, live only after Publish) — and, in edit mode, the Policies page's
// edit / delete icon buttons.
const RuleEditCells: FC<IProps> = ({ rule, isEditing, onToggle, onEdit, onDelete }) => (
  <>
    <TableCell align='center'>
      <Switch
        size='small'
        checked={rule.active}
        disabled={!isEditing}
        onChange={onToggle}
        inputProps={{ 'aria-label': `${rule.name} on/off` }}
      />
    </TableCell>
    {isEditing && (
      <TableCell align='center'>
        <Stack direction='row' spacing={1} justifyContent='center'>
          <IconButton
            size='small'
            className='routing-rule-action routing-rule-action--edit'
            aria-label={`Edit rule ${rule.name}`}
            onClick={onEdit}
          >
            <EditIcon fontSize='small' />
          </IconButton>
          <IconButton
            size='small'
            className='routing-rule-action routing-rule-action--delete'
            aria-label={`Delete rule ${rule.name}`}
            onClick={onDelete}
          >
            <ClearIcon fontSize='small' />
          </IconButton>
        </Stack>
      </TableCell>
    )}
  </>
);

export default RuleEditCells;
